// @flow
import React from 'react';

import { StyledH4 } from '../../presentational/headings/StyledH4';

export const GlobalDiscountLabelContainer = () => <StyledH4 text="Global Discount" />;
